import { CS } from "../../../../base/utils/styler";

export const tabTitleStyle: CS = {
    padding: '8px 10px',
    height: '47px',
    margin: '2px 0',
    cursor: 'pointer',
    userSelect: 'none',
    color: 'black',
    minWidth: '100px',
    textAlign: 'center',
    fontSize: '16px',
    opacity: '.5',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    '&:hover': {
        opacity: '.5'
    }
}

export const tabTitleSelectedStyle: CS = {
    backgroundColor: 'white',

    opacity: '1'
}

export const tabTitleUnselectedStyle: CS = {
    backgroundColor: '',

    opacity: '0.5'
}